import React from 'react'

import SetStatus from './SetStatus'
import Styles from './index.scss'

const Action = () => (
  <div className={`portlet light ${Styles['action-box']}`}>
    <div className="portlet-title">
      <h4>Action</h4>
    </div>
    <div className="portlet-body">
      <div className={`row ${Styles['action-content']}`}>
        <SetStatus />
      </div>
    </div>
  </div>
)

export default Action
